export default "__VITE_ASSET__ee01dfff__"